export const initDate = (isStartDate = false) => {
    const date = new Date();
    if (isStartDate) {
        date.setHours(0, 0, 0, 0);
    } else {
        date.setHours(23, 59, 59, 999);
    }
    return date;
};
